import Beneficiaries from './container'

export default Beneficiaries
